import { render, staticRenderFns } from "./ListaDePedidosCartao.vue?vue&type=template&id=49ab45ca&scoped=true"
import script from "./ListaDePedidosCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDePedidosCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListaDePedidosCartao.vue?vue&type=style&index=0&id=49ab45ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab45ca",
  null
  
)

export default component.exports